import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const SchoolAltIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m11.566 3.211-10 5.5v1.578l10 5.5h.868l8.666-4.767V16.5h1.8v-7l-.466-.789-10-5.5h-.868Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M4.631 17.078V13.66l6.646 3.655h1.446l6.646-3.655v3.42l-.498.804-6.468 3.235h-.806L5.13 17.883l-.498-.805Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m1.566 8.711 10-5.5h.868l10 5.5.466.789v7h-1.8v-5.478l-1.731.952v5.104l-.498.805-6.468 3.235h-.806L5.13 17.883l-.498-.805v-5.104L1.566 10.29V8.71Zm18.567.789L12 5.027 3.868 9.5 12 13.973 20.133 9.5Zm-7.7 6.289 5.136-2.825v3.558L12 19.306l-5.569-2.784v-3.558l5.135 2.825h.868Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `SchoolAltIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { SchoolAltIcon };
//# sourceMappingURL=SchoolAltIcon.mjs.map
